import { Framework } from '@/framework';

type ActionType = 'delete' | 'paste' | 'addOrDelRowOrColByCellsSelectedInfo';

export class TableAction extends Framework {
    private eventName = 'tableAction';

    emit = (actionType: ActionType) => {
        this.framework.service.events.emit(this.eventName, actionType);
    };

    on = (cb: (actionType: ActionType) => void) => {
        const listenerId = this.framework.service.events.on(this.eventName, cb);
        const rmListener = () => {
            this.framework.service.events.off(listenerId);
        };
        return rmListener;
    };
}
